export interface EuLanguageOption {
  i18nLanguage: string;
  locale: string;
  label: string;
}

export const EU_LANGUAGE_OVERRIDE_VALID_LOCALES = [
  'cs-CZ',
  'sk-SK',
  'de-AT',
  'ro-RO',
  'de-DE',
  'hu-HU',
  'en-GB'
] as const;

export const EU_LANGUAGE_SWITCHER_LOCALES = ['cs-CZ', 'sk-SK', 'de-AT', 'ro-RO', 'de-DE', 'hu-HU'] as const;

const LOCALE_TO_I18N: Record<string, string> = {
  'cs-CZ': 'cs',
  'sk-SK': 'sk',
  'de-AT': 'de-AT',
  'ro-RO': 'ro',
  'de-DE': 'de',
  'hu-HU': 'hu'
};

const ENGLISH_EU_LOCALE = 'en-GB';

const EU_LANGUAGE_OPTIONS: Record<string, EuLanguageOption[]> = {
  'cs-CZ': [
    { i18nLanguage: 'cs', locale: 'cs-CZ', label: 'Čeština' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ],
  'sk-SK': [
    { i18nLanguage: 'sk', locale: 'sk-SK', label: 'Slovenčina' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ],
  'de-AT': [
    { i18nLanguage: 'de-AT', locale: 'de-AT', label: 'Deutsch' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ],
  'ro-RO': [
    { i18nLanguage: 'ro', locale: 'ro-RO', label: 'Română' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ],
  'de-DE': [
    { i18nLanguage: 'de', locale: 'de-DE', label: 'Deutsch' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ],
  'hu-HU': [
    { i18nLanguage: 'hu', locale: 'hu-HU', label: 'Magyar' },
    { i18nLanguage: 'en-GB', locale: ENGLISH_EU_LOCALE, label: 'English' }
  ]
};

export function isEuLanguageSwitcherEnabled(locale: string): boolean {
  return EU_LANGUAGE_SWITCHER_LOCALES.includes(locale as (typeof EU_LANGUAGE_SWITCHER_LOCALES)[number]);
}

export function getEuLanguageOptions(locale: string): EuLanguageOption[] {
  return EU_LANGUAGE_OPTIONS[locale] || [];
}

export function getCurrentOptionFromLocale(locale: string): EuLanguageOption | undefined {
  const options = getEuLanguageOptions(locale);
  const i18nLang = LOCALE_TO_I18N[locale] || locale.split('-')[0];
  const isEnglish = locale === ENGLISH_EU_LOCALE;
  return (
    options.find(
      opt => opt.locale === locale || (isEnglish ? opt.i18nLanguage === 'en-GB' : opt.i18nLanguage === i18nLang)
    ) || options[0]
  );
}

export function getRegionLocaleForOptions(currentLocale: string, availableLocales: string[]): string {
  if (EU_LANGUAGE_SWITCHER_LOCALES.includes(currentLocale as (typeof EU_LANGUAGE_SWITCHER_LOCALES)[number])) {
    return currentLocale;
  }
  if (currentLocale === ENGLISH_EU_LOCALE) {
    for (const euLocale of EU_LANGUAGE_SWITCHER_LOCALES) {
      if (availableLocales.includes(euLocale)) {
        return euLocale;
      }
    }
    return currentLocale;
  }
  return currentLocale;
}
